export default __webpack_public_path__ + "static/media/down-arrow.ea62c400.svg";